import React, { useContext, useState } from "react";
// import AppContext from "../../../../Contexts/AppContext";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  IconButton,
  Slider,
  Divider,
  Tooltip,
  MenuItem,
  TextField,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import {
//   setLayerOpacity,
//   setLayerVisibility,
// } from "../../../../../services/MapCore/LayerGroupService";
import { useTranslation } from "react-i18next";

import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { WmsLegendComponent } from "../../../legends/WMSLegend";
// import { OverflowTooltip } from "../../../../CustomComponents/OverflowTooltip/OverflowTooltip";
import AppContext from "../../../../components/Contexts/AppContext";
import {
  setLayerOpacity,
  setLayerVisibility,
} from "../../../../services/MapCore/LayerGroupService";
import { OverflowTooltip } from "../../../../components/CustomComponents/OverflowTooltip/OverflowTooltip";

const LayerSettingsElement = ({ layer }) => {
  const { t, i18n } = useTranslation("main");
  const { map, modeOptions } = useContext(AppContext);

  const {
    visible,
    opacity,
    id,
    legend,
    name,
    controlSettingsComponent,
    styles,
  } = layer;

  const [layerVisibilityControl, setLayerVisibilityControl] = useState(visible);
  const [layerTransparencyControl, setLayerTransparencyControl] = useState(
    opacity * 100
  );
  const [hoverTools, setHoverTools] = useState(false);
  const [clickTools, setClickTools] = useState(false);
  const { updateLegend } = useContext(AppContext);
  const [expanded, setExpanded] = useState(false);

  const handleChange = () => {
    setExpanded(!expanded);
  };

  const handleToggleLayerVisibility = (layerId) => {
    const isNowVisible = !layer.visible;
    layer.setVisible(isNowVisible);
    const newVisibility = !layerVisibilityControl;
    setLayerVisibilityControl(newVisibility);
    setLayerVisibility(map, layerId, newVisibility);
  };

  const handleTransparencyChange = (_, newValue) => {
    setLayerTransparencyControl(newValue);
    const opacity = newValue / 100;
    setLayerOpacity(map, id, opacity);
  };

  const tools = layer?.getLayerTools(i18n);

  return (
    <Accordion
      key={id}
      sx={{
        marginBottom: "0.5rem",
        backgroundColor: layerVisibilityControl ? "" : "var(--color-txt-3)",
        color: layerVisibilityControl ? "" : "var(--color-bg-3)",
        ...(modeOptions.ASBESTOS_CLICK.includes(id) && {
          outline: "2px solid #ff4081",
          outlineOffset: "-2px" /* Empuja el borde hacia adentro */,
        }),
        borderRadius: "4px",
      }}
      expanded={expanded}
      onChange={handleChange}
    >
      <AccordionSummary
        sx={{
          "& .MuiAccordionSummary-expandIconWrapper": {
            transform: "none !important", // Desactiva la rotación
            "&.Mui-expanded .accordionExpandIcon": {
              transform: "rotate(-180deg)",
            },
          },
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          "& .MuiAccordionSummary-content": {
            overflow: "hidden",
          },
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            flexGrow: "1",
            overflow: "hidden",
          }}
        >
          <OverflowTooltip text={name?.[i18n.language]} />
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            paddingLeft: "8px",
          }}
        >
          <div
            style={{
              display: "flex",
              maxWidth:
                tools?.length !== 1
                  ? clickTools || hoverTools
                    ? "200px"
                    : "0px"
                  : "",
              transition: "max-width 0.5s ease-in",
              overflow: "hidden",
            }}
            onMouseEnter={() => setHoverTools(true)}
            onMouseLeave={() => setHoverTools(false)}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            {tools?.map((tool) => tool.button)}
          </div>
          {tools?.length > 1 && (
            <IconButton
              sx={{
                backgroundColor: clickTools
                  ? "lightgrey!important"
                  : "transparent",
                transition: "transform 300ms ease-in-out",
                transform: clickTools || hoverTools ? "rotate(90deg)" : 0,
              }}
              onMouseEnter={() => setHoverTools(true)}
              onMouseLeave={() => setHoverTools(false)}
              onClick={(ev) => {
                ev.stopPropagation();
                setClickTools((prev) => !prev);
              }}
            >
              <MoreHorizIcon />
            </IconButton>
          )}
          <Tooltip title={t("toggle_visibility")}>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                handleToggleLayerVisibility(id);
              }}
              edge="start"
              aria-label="toggle visibility"
            >
              {layerVisibilityControl ? (
                <VisibilityIcon />
              ) : (
                <VisibilityOffIcon />
              )}
            </IconButton>
          </Tooltip>
          <Tooltip title={t(expanded ? "contract" : "expand")}>
            <IconButton
              className="accordionExpandIcon"
              sx={{
                transform: expanded ? "rotate(180deg)" : "",
                transition: "transform 0.3s ease-in-out!important",
              }}
            >
              <ExpandMoreIcon />
            </IconButton>
          </Tooltip>
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <Divider style={{ marginBottom: "1rem" }} />
        <Typography variant="subtitle1">
          {t("visibility")}: {Math.round(layerTransparencyControl)}%
        </Typography>
        <Slider
          value={layerTransparencyControl}
          onChange={handleTransparencyChange}
          aria-labelledby="transparency-slider"
          min={0}
          max={100}
          step={1}
          sx={{ color: "var(--color-primary)" }}
        />

        <Divider style={{ marginBottom: "1rem" }} />
        {styles?.length > 1 && (
          <div>
            <TextField
              value={layer.style_selected_geoserver_style_id}
              onChange={(e) => {
                layer.changeLegendStyle(e.target.value, map);
                updateLegend();
              }}
              label={t("visualization_selector")}
              fullWidth
              select={true}
              InputLabelProps={{ shrink: true }}
            >
              {layer.styles.map((style) => {
                const { geoserver_style_id, name } = style.style;
                return (
                  <MenuItem key={geoserver_style_id} value={geoserver_style_id}>
                    {name?.[i18n.language]}
                  </MenuItem>
                );
              })}
            </TextField>
          </div>
        )}
        {controlSettingsComponent}
        {legend && (
          <div
            style={{
              overflowX: "auto",
              backgroundColor: "white",
              color: "black",
              padding: "0.6rem",
              borderRadius: "1rem",
            }}
          >
            {/* <Typography>{t("legend")}</Typography> */}
            <Typography>Map legend</Typography>
            <WmsLegendComponent legend={legend} />
          </div>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export { LayerSettingsElement };
